import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
   @font-face{font-family:roboto;font-style:normal;font-weight:100;src:local('Roboto'),url(https://fonts.cdnfonts.com/s/12165/Roboto-Regular.woff) format('woff')} `}
  />
);

export default Fonts;
